import { apiClient } from './apiClient';

export interface BccEmailSettingResponse {
    bccEmail: string | null;
}

export const bccEmailService = {
    get: (): Promise<BccEmailSettingResponse> =>
        apiClient.get<BccEmailSettingResponse>('/company-settings/bcc-email'),

    set: (bccEmail: string | null): Promise<void> =>
        apiClient.put<void>('/company-settings/bcc-email', { bccEmail }),
};
